/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';
import { AWSRegionsEnum } from './aWSRegionsEnum';


export interface CreateIRRSpec { 
    irr_name: string;
    /**
     * Java Run Time version
     */
    jre_version?: string;
    /**
     * Lambda Zip file name
     */
    lambda_zip_file_name?: string;
    preferred_az_id: string;
    region: AWSRegionsEnum;
    service_type: ServiceTypeEnum;
    /**
     * Requested Deployment version
     */
    version?: string;
}
export namespace CreateIRRSpec {
}


